import api from './api';

// Relatório Geral
export const obterRelatorioGeral = async () => {
 try {
   console.log('Iniciando requisição para obter relatório geral');
   const response = await api.get('/relatorios/geral');
   console.log('Resposta recebida:', response.data);
   return response.data;
 } catch (error) {
   console.error('Erro ao obter relatório geral:', error);
   console.error('Status do erro:', error.response?.status);
   console.error('Mensagem do erro:', error.response?.data);
   throw error;
 }
};

// Relatórios de Instituição
export const obterRelatorioInstituicao = async (instituicaoId, params) => {
 try {
   console.log(`Obtendo relatório da instituição ${instituicaoId}`, { params });
   const response = await api.get(`/relatorios/instituicao/${instituicaoId}`, { params });
   console.log('Resposta recebida:', response.data);
   return response.data;
 } catch (error) {
   console.error('Erro ao obter relatório da instituição:', error);
   console.error('Status:', error.response?.status);
   console.error('Dados:', error.response?.data);
   throw error;
 }
};

export const obterRelatorioPorPeriodo = async (instituicaoId, params) => {
 try {
   console.log(`Obtendo relatório por período - instituição ${instituicaoId}`, { params });
   const response = await api.get(`/relatorios/instituicao/${instituicaoId}/periodo`, { params });
   console.log('Dados recebidos:', response.data);
   return response.data;
 } catch (error) {
   console.error('Erro ao obter relatório por período:', error);
   console.error('Status:', error.response?.status);
   console.error('Detalhes:', error.response?.data);
   throw error;
 }
};

export const obterRelatorioCursos = async (instituicaoId, params) => {
 try {
   console.log(`Obtendo relatório de cursos - instituição ${instituicaoId}`, { params });
   const response = await api.get(`/relatorios/instituicao/${instituicaoId}/cursos`, { params });
   console.log('Dados dos cursos:', response.data);
   return response.data;
 } catch (error) {
   console.error('Erro ao obter relatório de cursos:', error);
   console.error('Status:', error.response?.status);
   console.error('Detalhes:', error.response?.data);
   throw error;
 }
};

// Em relatorioService.js, modifique exportarRelatorioDemografico:
export const exportarRelatorioDemografico = async (instituicaoId, formato, params) => {
  try {
    const dadosInstituicao = await obterRelatorioInstituicao(instituicaoId);
    const logoPath = dadosInstituicao?.instituicao?.logo;
    
    let parametrosFinais = {
      ...Object.fromEntries(params instanceof URLSearchParams ? params : []),
      instituicaoId: instituicaoId
    };

    if (logoPath) {
      // Enviar o caminho completo sem modificação
      parametrosFinais.logoPath = logoPath;
    }

    console.log('Parâmetros finais:', parametrosFinais);

    const response = await api.get(
      `/relatorios/instituicao/${instituicaoId}/demografia/export/${formato}`,
      {
        params: parametrosFinais,
        responseType: 'blob',
        headers: {
          'Accept': formato === 'excel' 
            ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            : 'application/pdf'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao exportar relatório:', error);
    throw error;
  }
};

export const obterRelatorioPorClasses = async (instituicaoId, params) => {
 try {
   console.log(`Obtendo relatório por classes - instituição ${instituicaoId}`, { params });
   const response = await api.get(`/relatorios/instituicao/${instituicaoId}/classes`, { params });
   console.log('Dados das classes:', response.data);
   return response.data;
 } catch (error) {
   console.error('Erro ao obter relatório por classes:', error);
   console.error('Status:', error.response?.status);
   console.error('Detalhes:', error.response?.data);
   throw error;
 }
};

export const obterRelatorioCampanhasPerformance = async (instituicaoId, params) => {
 try {
   console.log(`Obtendo relatório de performance de campanhas - instituição ${instituicaoId}`, { params });
   const response = await api.get(`/relatorios/instituicao/${instituicaoId}/campanhas-performance`, { params });
   console.log('Dados de performance:', response.data);
   return response.data;
 } catch (error) {
   console.error('Erro ao obter relatório de performance das campanhas:', error);
   console.error('Status:', error.response?.status);
   console.error('Detalhes:', error.response?.data);
   throw error;
 }
};

export const obterRelatorioTendencias = async (instituicaoId, params) => {
 try {
   console.log(`Obtendo relatório de tendências - instituição ${instituicaoId}`, { params });
   const response = await api.get(`/relatorios/instituicao/${instituicaoId}/tendencias`, { params });
   console.log('Dados de tendências:', response.data);
   return response.data;
 } catch (error) {
   console.error('Erro ao obter relatório de tendências:', error);
   console.error('Status:', error.response?.status);
   console.error('Detalhes:', error.response?.data);
   throw error;
 }
};

export const exportarRelatorioCursos = async (instituicaoId, formato, params) => {
  try {
    console.log(`Exportando relatório de cursos - instituição ${instituicaoId}, formato: ${formato}`);
    
    const response = await api.get(
      `/relatorios/instituicao/${instituicaoId}/cursos/exportar/${formato}`,
      {
        params: params instanceof URLSearchParams ? Object.fromEntries(params) : params,
        responseType: 'arraybuffer',
        headers: {
          'Accept': formato === 'excel' 
            ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            : 'application/pdf'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao exportar relatório de cursos:', error);
    throw error;
  }
};

export const exportarRelatorioClasses = async (instituicaoId, formato, params) => {
  try {
    console.log(`Exportando relatório de classes - instituição ${instituicaoId}, formato: ${formato}`);
    
    const response = await api.get(
      `/relatorios/instituicao/${instituicaoId}/classes/exportar/${formato}`,
      {
        params: params instanceof URLSearchParams ? Object.fromEntries(params) : params,
        responseType: 'arraybuffer',
        headers: {
          'Accept': formato === 'excel' 
            ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            : 'application/pdf'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao exportar relatório de classes:', error);
    throw error;
  }
};




export const obterRelatorioDemografico = async (instituicaoId, params) => {
  try {
    console.log('Iniciando busca de dados demográficos:', { instituicaoId, params });
    
    let demografiaParams = {};
    if (params instanceof URLSearchParams) {
      demografiaParams = Object.fromEntries(params.entries());
    } else {
      demografiaParams = params;
    }

    console.log('Parâmetros formatados:', demografiaParams);

    const response = await api.get(
      `/relatorios/instituicao/${instituicaoId}/demografia`,
      { 
        params: demografiaParams,
        timeout: 30000
      }
    );
    
    console.log('Resposta bruta:', response.data);

    // Garantir formato de array
    const dados = Array.isArray(response.data) ? response.data : [response.data].filter(Boolean);
    
    // Validar estrutura dos dados
    const dadosFormatados = dados.map(item => ({
      genero: item.genero || 'Não Informado',
      total: parseInt(item.total) || 0,
      mediaIdade: item.mediaIdade || 'N/A',
      preInscritos: Array.isArray(item.preInscritos) ? item.preInscritos : []
    }));

    console.log('Dados formatados:', dadosFormatados);
    return dadosFormatados;
    
  } catch (error) {
    console.error('Erro detalhado:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    
    if (error.code === 'ECONNABORTED') return [];
    if (error.response?.status === 404) return [];
    
    throw error;
  }
};

export const exportarRelatorio = async (instituicaoId, formato, params) => {
  try {
    console.log(`Exportando relatório - instituição ${instituicaoId}, formato: ${formato}`, { params });
    const response = await api.get(
      `/relatorios/instituicao/${instituicaoId}/export/${formato}`,
      {
        params,
        responseType: 'blob',
        headers: {
          'Accept': formato === 'pdf' 
            ? 'application/pdf' 
            : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    console.log('Relatório exportado com sucesso');
    return response.data;
  } catch (error) {
    console.error('Erro ao exportar relatório:', error);
    console.error('Status:', error.response?.status);
    console.error('Detalhes:', error.response?.data);
    throw error;
  }
 };

// Relatórios Financeiros
export const obterRelatorioFinanceiro = async (instituicaoId, params) => {
 try {
   console.log(`Obtendo relatório financeiro - instituição ${instituicaoId}`, { params });
   const response = await api.get(`/relatorios/financeiro/instituicao/${instituicaoId}`, { params });
   console.log('Dados financeiros:', response.data);
   return response.data;
 } catch (error) {
   console.error('Erro ao obter relatório financeiro:', error);
   console.error('Status:', error.response?.status);
   console.error('Detalhes:', error.response?.data);
   throw error;
 }
};

export const exportarRelatorioFinanceiro = async (instituicaoId, formato, params) => {
 try {
   console.log(`Exportando relatório financeiro - instituição ${instituicaoId}, formato: ${formato}`, { params });
   const response = await api.get(`/relatorios/financeiro/instituicao/${instituicaoId}/export/${formato}`, {
     params,
     responseType: 'blob'
   });
   console.log('Relatório financeiro exportado com sucesso');
   return response.data;
 } catch (error) {
   console.error('Erro ao exportar relatório financeiro:', error);
   console.error('Status:', error.response?.status);
   console.error('Detalhes:', error.response?.data);
   throw error;
 }
};

export const obterAnaliseInadimplencia = async (instituicaoId, params) => {
 try {
   console.log(`Obtendo análise de inadimplência - instituição ${instituicaoId}`, { params });
   const response = await api.get(`/relatorios/financeiro/instituicao/${instituicaoId}/inadimplencia`, { params });
   console.log('Dados de inadimplência:', response.data);
   return response.data;
 } catch (error) {
   console.error('Erro ao obter análise de inadimplência:', error);
   console.error('Status:', error.response?.status);
   console.error('Detalhes:', error.response?.data);
   throw error;
 }
};

export const obterAnaliseMetodosPagamento = async (instituicaoId, params) => {
 try {
   console.log(`Obtendo análise de métodos de pagamento - instituição ${instituicaoId}`, { params });
   const response = await api.get(`/relatorios/financeiro/instituicao/${instituicaoId}/metodos-pagamento`, { params });
   console.log('Dados dos métodos de pagamento:', response.data);
   return response.data;
 } catch (error) {
   console.error('Erro ao obter análise de métodos de pagamento:', error);
   console.error('Status:', error.response?.status);
   console.error('Detalhes:', error.response?.data);
   throw error;
 }
};
export const obterOpcoesFiltroDemografia = async (instituicaoId) => {
  try {
    console.log(`Obtendo opções de filtro demográfico - instituição ${instituicaoId}`);
    // Mudando de /demografia/opcoes para /demografia/filtros-opcoes
    const response = await api.get(`/relatorios/instituicao/${instituicaoId}/demografia/filtros-opcoes`);
    
    console.log('Opções de filtro recebidas:', response.data);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      console.warn('Nenhuma opção de filtro encontrada');
      return {
        tipoInstituicao: 'desconhecido',
        cursos: [],
        classes: []
      };
    }

    console.error('Erro ao obter opções de filtro demográfico:', error);
    console.error('Status:', error.response?.status);
    console.error('Detalhes:', error.response?.data);
    throw error;
  }
};